import { Controller } from "@hotwired/stimulus"

// Click target=button to copy data-clipboard-source-target's value to clipboard.
// Briefly swaps the button label to data-clipboard-copied-value.
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { copied: { type: String, default: "Copied!" } }

  async copy(event) {
    event.preventDefault()
    const text = this.sourceTarget.value || this.sourceTarget.textContent
    try {
      await navigator.clipboard.writeText(text.trim())
    } catch (_e) {
      // Fallback: select + execCommand
      this.sourceTarget.select?.()
      document.execCommand?.("copy")
    }
    if (this.hasButtonTarget) {
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = this.copiedValue
      setTimeout(() => { this.buttonTarget.textContent = original }, 1200)
    }
  }
}
